import { connect } from 'react-redux';
import { compose } from 'redux';
import withReducer from '@Hooks/withReducer';
import {
  closeResetPasswordWithTokenDialog,
  setConfirmationPassword as setConfirmationPasswordAction,
  setNewPassword as setNewPasswordAction,
  submit,
  trackAdobeAnalyticsError,
} from './ResetPasswordWithTokenDialogActions';
import ResetPasswordWithTokenDialog from './ResetPasswordWithTokenDialog';
import ResetPasswordWithTokenDialogReducer from './ResetPasswordWithTokenDialogReducer';
import { resetPasswordWithTokenDialogReducerKey } from './ResetPasswordWithTokenDialogConstants';
import {
  confirmationPassword as confirmationPasswordSelector,
  isLoading as isLoadingSelector,
  newPassword as newPasswordSelector,
} from './ResetPasswordWithTokenDialogSelectors';

const mapStateToProps = (state) => ({
  isLoading: isLoadingSelector(state),
  newPassword: newPasswordSelector(state),
  confirmationPassword: confirmationPasswordSelector(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  close: () => dispatch(closeResetPasswordWithTokenDialog()),
  trackAdobeAnalyticsError: (errors, prefix) => trackAdobeAnalyticsError(errors, prefix),
  setNewPassword: (password) => dispatch(setNewPasswordAction(password)),
  setConfirmationPassword: (password) => dispatch(setConfirmationPasswordAction(password)),
  submit: () => dispatch(submit(ownProps.token)),
});

export default compose(
  withReducer(resetPasswordWithTokenDialogReducerKey, ResetPasswordWithTokenDialogReducer),
  connect(mapStateToProps, mapDispatchToProps)
)(ResetPasswordWithTokenDialog);
